import { Fragment, useContext, useEffect, useState } from "react";
import { useSortBy } from "react-instantsearch";
import { GlobalContext } from "../../Context/GlobalContext";
import { setStoredSortBy, SORTBY_OPTION } from "../../Layout/Common/algoliaInstantLib";
import { useLocation } from "react-router-dom";

export const SoryByOption = () => {
  const { options, refine, currentRefinement } = useSortBy({
    items: SORTBY_OPTION,
  });
  const [selected, setSelected] = useState(null);
  const location = useLocation();

  const handleRefine = (value) => {
    setStoredSortBy(value);
    refine(value);
  };

  useEffect(() => {
    var selectedItem = options.find((i) => i.value == currentRefinement);
    setSelected(selectedItem);
  }, [currentRefinement, location]);

  return (
    <Fragment>
      {selected && (
        <div className="filters-list">
          <div className="sortby-filter">
            <div className="dropdown filterSortby">
              <button
                className="btn filter-btn manufatureFilter sortbyFilter dropdown-toggle"
                type="button"
                id="sorbyDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span>Sort by </span>:<span id="sortbyFilter-selected">{selected ? selected.label : ""}</span>
                <i className="fa-solid fa-chevron-down" />
              </button>
              <div
                className="dropdown-menu manufatureFilter-dropdownMenu sorbyFilter-dropdown dropdown-menu-end dropdown-menu-lg-start"
                aria-labelledby="sorbyDropdown"
              >
                <div className="manufacture-filter-list">
                  {options &&
                    options.map((item, index) => (
                      <div className="manufacture-filterList-content sortByFilter-content" key={item.id ?? index}>
                        <div className="common-radio-selection">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="sortByRadio"
                            id={`sortBy-${item.value}`}
                            onChange={() => handleRefine(item.value)}
                            checked={item.value === currentRefinement}
                          />
                          <label className="form-check-label" htmlFor={`sortBy-${item.value}`}>
                            {item.label}
                          </label>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};
